import React from "react";
import { Modal } from "../../../../../../shared/Modal/Modal.js";
import { Button } from "../../../../../../shared/Button/Button.js";
import { InfoIcon } from "../../../../../../assets/Icons/InfoIcon.js";
import styles from "./scss/ClearentSurchargeEnrollmentModal.module.scss";

const StripeSurchargeEnrollmentModal = ({ onContinue, onBack }) => {
  return (
    <Modal
      isOpen
      onClose={onBack}
      header={
        <Modal.Title>
          <span className={styles.titleWithIcon}>
            <InfoIcon width="22px" />
            Surcharges Not Yet Available
          </span>
        </Modal.Title>
      }
      footer={
        <div className={styles.footerContainer}>
          {onContinue ? (
            <>
              <Button variant="outlined" onClick={onBack}>
                Back
              </Button>
              <Button onClick={onContinue}>Continue</Button>
            </>
          ) : (
            <Button onClick={onBack}>Close</Button>
          )}
        </div>
      }
      footerNoBorder
    >
      <div className={styles.content}>
        <p>Interested in enabling Surcharges in Aesthetic Record?</p>
        <p>
          Please contact our Chat Support team, and we&apos;ll be happy to
          help you get started.
        </p>
      </div>
    </Modal>
  );
};

export default StripeSurchargeEnrollmentModal;
